import { useEffect } from 'react';

const OPENS_KEY = 'bullivo_app_opens';
const DISMISSED_KEY = 'bullivo_banner_dismissed';
const FIRST_SHOW = 3;
const SHOW_EVERY = 5;

// Reiner Timing-Trigger: oeffnet die PaywallView beim 3. Start und danach alle 5 Starts
export default function PremiumBanner({ onUpgrade }) {
  useEffect(() => {
    try {
      const opens = parseInt(localStorage.getItem(OPENS_KEY) || '0', 10) + 1;
      localStorage.setItem(OPENS_KEY, String(opens));

      const dismissed = localStorage.getItem(DISMISSED_KEY);
      const dismissedAt = dismissed ? parseInt(dismissed, 10) : 0;

      if (dismissedAt >= opens - 1) return;

      if (opens >= FIRST_SHOW && (opens - FIRST_SHOW) % SHOW_EVERY === 0) {
        localStorage.setItem(DISMISSED_KEY, String(opens));
        onUpgrade?.();
      }
    } catch {}
  }, []); // eslint-disable-line

  return null; // kein eigenes UI
}
